import React, { memo, useEffect } from 'react'
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom'

const AppRoutes = ({ appRoutes, setHeader }) => {  
  let location = useLocation()  
  const content = (    
    <Routes location={location}>
      {appRoutes.map((menuItem) => {
        if (menuItem.isExact) {
          return (
            <Route
              key={`${menuItem.path}`}
              exact
              path={menuItem.path}
              element={
                  <menuItem.component setHeader={setHeader} />
              }
            />
          )
        } else {
          return (
            <Route
              key={menuItem.path}
              path={menuItem.path}
              element={
                  <menuItem.component setHeader={setHeader} />
              }
            />
          )
        }
      })}
            <Route path='loggedIn' element={<NoMatch />} />

      <Route path='*' element={<NoMatch />} />
    </Routes>
  )
  
    return content
}

export default memo(AppRoutes)

function NoMatch() {
  const location= useLocation();  
  const navigate = useNavigate()
  // let location = useLocation()
  

  useEffect(() => {
    console.log('no matching route found, back to dashboard. route:'+location.pathname)
    navigate('/')  
  })
  return <div></div>
}
